export default "__VITE_ASSET__BpRt7xyK__"